import { createSelector } from "reselect";
import { getDoctorDashboardState } from "../store/doctor-dashboard.selectors";

export class DoctorsDashboardRuntimeSelectors {
    static readonly state = createSelector(getDoctorDashboardState, state => state.runtime);

    static readonly inProcess = createSelector(DoctorsDashboardRuntimeSelectors.state, state => state.inProcess);
    static readonly currentOrganization = createSelector(DoctorsDashboardRuntimeSelectors.state, state => state.currentOrganization);
}